// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartDataTable_wrapper__YwyFC","toggle":"ChartDataTable_toggle__ckZ+u","table":"ChartDataTable_table__v8VfC","caption":"ChartDataTable_caption__w+vdZ"};